import { ConsignmentStockOutCreatePage } from "@/features/consignment-stockout/pages/ConsignmentStockOutCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockout/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["consignment_stock_out.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ConsignmentStockOutCreatePage,
});
